module.exports = __webpack_public_path__ + "img/4C462E_6D876C_9AAC8F_9AABA6-256px.4f29ee2c.png";